import { useMemo } from 'react';
import { UsersQueries } from '@frontend/api-users';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Avatar, Chip, Text } from '@frontend/design-system';
import { styles } from './styles';

type TaggedUserProps = {
  userName?: string;
  userId?: string;
  variant: 'chip' | 'badge';
};
export const TaggedUser = ({ userName, userId, variant }: TaggedUserProps) => {
  const { data: user } = UsersQueries.useGetUserDetails(userId || '');

  const actionUserName = useMemo(() => {
    if (userName) {
      return userName === 'SYSTEM_SCHEDULED_INVOICE' ? 'System Scheduled Invoice' : userName;
    }
    const concatUser = `${user?.firstName} ${user?.lastName}`;
    return user?.firstName || user?.lastName ? concatUser : undefined;
  }, [user, userName]);

  if (!actionUserName) return null;

  if (variant === 'badge') {
    return (
      <div className='tagged-user tagged-user--badge' css={styles.userBadge}>
        <Icon name='user' size={16} />
        <Text size='small'>{actionUserName}</Text>
      </div>
    );
  }

  return (
    <Chip
      className='tagged-user tagged-user--chip'
      variant='default'
      maxWidth='max-content'
      leftElement={
        <Avatar
          bypassColor={{ fill: theme.colors.neutral30, text: theme.colors.white }}
          name={actionUserName}
          size='xxs'
        />
      }
    >
      <Text size='medium'>{actionUserName}</Text>
    </Chip>
  );
};
